/**
 * @fileoverview Agent definition for world-species-snapshotter-v3.
 *
 * This agent analyzes a chapter and updates a world species' state,
 * creating a snapshot that reflects any changes from the chapter events.
 *
 * @category world-building.species.snapshots
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'world-species-snapshotter-v3',
  kind: 'primitive',
  name: 'World Species Snapshotter',
  description: 'Updates a world species state after a chapter, creating a point-in-time snapshot.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.species.snapshots',
    usedBy: ['use-world-species-snapshotter-v3.ts'],
    usedInComposites: [],
    relatedAgents: ['world-species-details-generator-v3'],
  },
};
